module.exports = __webpack_public_path__ + "img/ts4.24b852d6.png";